import { useState as i } from "react";
import o from "../../utils/useInterval.js";
import { AnimatedTextScroll as c } from "./AnimatedTextScroll.js";
import { jsx as n, Fragment as f } from "react/jsx-runtime";
function a({
  animation: r,
  style: l
}) {
  if (!r)
    return null;
  const {
    type: u,
    words: t
  } = r, [e, m] = i(0);
  return o(() => {
    m((e + 1) % ((t == null ? void 0 : t.length) || 0));
  }, 2500), (t == null ? void 0 : t.length) === 0 ? null : u === "scroll_words" && t.length > 1 ? /* @__PURE__ */ n(c, {
    words: t,
    currIdx: e,
    style: l
  }) : /* @__PURE__ */ n(f, {
    children: t == null ? void 0 : t[0]
  });
}
export {
  a as AnimatedText
};
